import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import NavigationHeader from "../../components/ui/NavigationHeader";
import MainNavigation from "../../components/ui/MainNavigation";
import BreadcrumbNavigation from "../../components/ui/BreadcrumbNavigation";
import Icon from "../../components/AppIcon";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import CategoryTree from "./components/CategoryTree";
import CategoryDetails from "./components/CategoryDetails";
import CategoryProducts from "./components/CategoryProducts";
import BulkActionsModal from "./components/BulkActionsModal";
import DeleteConfirmationModal from "./components/DeleteConfirmationModal";
import { useDispatch, useSelector } from "react-redux";
import {
  createCategorieservice,
  createSubCategorieservice,
  deleteCategorieservice,
  getAllCategoriesService,
  getCategoryByIdService,
  updateCategorieservice,
} from "redux/services/categories_service";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import AddSubCategoryModal from "./components/AddSubCategoryModal";
import { setCategoryInfoNull } from "redux/slices/categories";
import EditSubCategoryModal from "./components/EditSubCategoryModal";

const CategoryManagement = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { categoryList, metaCategory, categoryInfo } = useSelector(
    (state) => state.categories
  );

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  const [openEditSubCategory, setOpenEditSubCategory] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [activeTab, setActiveTab] = useState("details");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedParentCategory, setSelectedParentCategory] = useState(null);
  const [showAddSubCategoryModal, setShowAddSubCategoryModal] = useState(false);

  // Mock user data
  const user = {
    name: t("userName"),
    email: t("userEmail"),
    avatar:
      "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150",
  };

  // State to hold categories
  const [categories, setCategories] = useState([]);

  const handleSidebarToggle = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  // عدل handleCategorySelect: حدد الـ category واجلب sub-categories
  const handleCategorySelect = async (category) => {
    // dispatch(getCategoryByIdService(category?.id))
    setSelectedCategory(category);
    setIsEditing(false);
    setActiveTab("details");

    // جلب sub-categories عبر API
    if (category.id) {
      dispatch(getCategoryByIdService(category.id)).then((response) => {
        if (response?.payload?.status === 200 || response?.payload?.data) {
          // subCategories ستُحدث في Redux state
          console.log("Sub-categories loaded:", response.payload.data);
        }
      });
    }
  };

  const handleSubCategorySelect = async (category) => {
    console.log("sub cat");
    console.log(category);
    setOpenEditSubCategory(true);
    setSelectedSubCategory(category);
  };

  const handleSelectCancel = async (category) => {
    dispatch(setCategoryInfoNull());
    setErrors({});
    setIsEditing(false);
  };

  // Handler جديد لفتح modal الـ add sub-category
  const handleOpenAddSubCategoryModal = () => {
    if (selectedCategory) {
      setSelectedParentCategory(selectedCategory);
      setShowAddSubCategoryModal(true);
    } else {
      toast.error(t("selectCategoryFirst")); // أضف ترجمة لـ "يرجى اختيار فئة أولاً"
    }
  };

  const handleCategoryUpdate = (updatedCategory) => {
    const formData = new FormData();
    formData.append(
      "translations[ar][name]",
      updatedCategory?.translations?.ar?.name
    );
    formData.append("_method", "PUT");
    formData.append("image", updatedCategory?.image);
    formData.append("order", updatedCategory?.order);
    dispatch(
      updateCategorieservice({ id: selectedCategory.id, formData: formData })
    ).then((response) => {
      if (
        response?.payload?.status == 200 ||
        response?.payload?.status == 201
      ) {
        toast(t("تم التحديث بنجاح"));
        dispatch(getAllCategoriesService({ page: 1 }));
      }
    });

    setSelectedCategory(updatedCategory);
  };

  const handleCategoryCreate = async (newCategory) => {
    const formData = new FormData();
    formData.append("name", newCategory?.translations?.ar?.name);
    formData.append("image", newCategory?.image);
    //  formData.append("order", newCategory?.order);
    await dispatch(createCategorieservice(formData)).then((response) => {
      if (
        response?.payload?.status == 200 ||
        response?.payload?.status == 201
      ) {
        toast(t("addedSuccess"));
        dispatch(getAllCategoriesService({ page: 1 }));
      }
    });
  };

  // أصلح handleAddSubCategory: استخدم subCategoryData و FormData مع dispatch
  const handleAddSubCategory = async (subCategoryData) => {
    const formData = new FormData();
    try {
      formData.append("parent_category_id", selectedCategory.id);
      formData.append(
        "translations[ar][name]",
        subCategoryData?.translations?.ar?.name
      );

      if (subCategoryData?.image && subCategoryData.image.length > 0) {
        for (let i = 0; i < subCategoryData.image.length; i++) {
          console.log(subCategoryData.image[i]);
          formData.append("image", subCategoryData.image[i]);
        }
      }
      formData.append("order", subCategoryData?.order || 0);

      dispatch(createSubCategorieservice(formData)).then((response) => {
        if (
          response?.payload?.status == 200 ||
          response?.payload?.status == 201
        ) {
          toast(t("addedSuccess"));
          // أعد جلب sub-categories للـ parent
          dispatch(getCategoryByIdService(selectedParentCategory.id));
          // أو أعد جلب كل الـ categories
          dispatch(getAllCategoriesService({ page: 1 }));
          setShowAddSubCategoryModal(false);
          setSelectedParentCategory(null);
        } else {
          toast.error(t("addFailed")); // أضف ترجمة للخطأ
        }
      });
    } catch (error) {
      console.error("Error adding sub-category:", error);
      toast.error(t("errorOccurred"));
    }
  };

  const handleCategoryDelete = (categoryId) => {
    const findCategory = (categories, id) => {
      for (const category of categories) {
        if (category.id === id) return category;
        if (category.children) {
          const found = findCategory(category.children, id);
          if (found) return found;
        }
      }
      return null;
    };

    const categoryToDelete = findCategory(categories, categoryId);
    setCategoryToDelete(categoryToDelete);
    setShowDeleteModal(true);
  };

  const handleUpdateSubCategory = async (subCategoryData) => {
    const formData = new FormData();
    formData.append(
      "translations[ar][name]",
      subCategoryData?.translations?.ar?.name
    );
    formData.append("_method", "PUT");
    if (subCategoryData?.image && subCategoryData.image.length > 0) {
      for (let i = 0; i < subCategoryData.image.length; i++) {
        console.log(subCategoryData.image[i]);
        formData.append("image", subCategoryData.image[i]);
      }
    }
    // formData.append("image", subCategoryData?.image);
    formData.append("order", subCategoryData?.order);
    dispatch(
      updateCategorieservice({ id: selectedSubCategory.id, formData: formData })
    ).then((response) => {
      if (
        response?.payload?.status == 200 ||
        response?.payload?.status == 201
      ) {
        toast(t("تم التحديث بنجاح"));
        dispatch(getCategoryByIdService(selectedCategory.id));
        setOpenEditSubCategory(false);
      }
    });
  };
  //handleSubCategoryDelete
  const handleSubCategoryDelete = (categoryId) => {
    dispatch(deleteCategorieservice(categoryId)).then((response) => {
      if (response?.payload?.status == 200) {
        toast(t("deletedSuccess"));

        dispatch(getCategoryByIdService(selectedCategory.id));
      }
    });
  };

  const handleDeleteConfirm = async (categoryId) => {
    await dispatch(deleteCategorieservice(categoryId)).then((response) => {
      if (response?.payload?.status == 200) {
        toast(t("deletedSuccess"));
        dispatch(getAllCategoriesService({ page: 1 }));
        // إذا كانت sub-category، أعد جلب sub-categories للـ parent
        if (selectedCategory && selectedCategory.id !== categoryId) {
          dispatch(getCategoryByIdService(selectedCategory.id));
        }
        setShowDeleteModal(false);
        setCategoryToDelete(null);
      }
    });
  };

  const handleBulkAction = (actionData) => {
    if (actionData.action === "delete") {
      selectedCategories.forEach((categoryId) => {
        handleDeleteConfirm(categoryId);
      });
    }
    setSelectedCategories([]);
    setShowBulkModal(false);
  };

  const fetchCategories = (page) => {
    dispatch(getAllCategoriesService({ page }))
      .then((response) => {
        if (response.payload) {
          setCategories(response.payload.data?.data?.data || []); // Uncommented and added fallback
          setTotalPages(response.payload?.data?.data?.last_page); // Uncommented and added fallback

          return response.payload;
        } else {
          console.warn("No payload in response");
          return null; // Or throw an error if needed
        }
      })
      .then((payload) => {
        // Second .then: Only runs if the first .then returns a value
        if (payload) {
          console.log("Processing in second .then:", payload);
          // Add any additional logic here, e.g., further data manipulation
        }
      })
      .catch((error) => {
        console.error("Error in dispatch:", error); // Handle rejections
      });
  };

  useEffect(() => {
    fetchCategories(currentPage);
  }, [dispatch, currentPage]);

  useEffect(() => {
    setCategories(categoryList);
  }, [dispatch, categoryList]);

  return (
    <div className="min-h-screen bg-surface">
      <Helmet>
        <title>{t("title")}</title>
        <meta name="description" content={t("description")} />
      </Helmet>

      {/* باقي الكود كما هو: Navigation, Header, Search */}

      {/* Content Area */}
      <div className="p-6">
        <div className="grid grid-cols-12 gap-6 h-[calc(100vh-280px)]">
          {/* Left Panel - Category Tree */}
          <div className="col-span-12 lg:col-span-5 bg-white rounded-lg border border-border shadow-elevation-1">
            <div className="h-full flex flex-col">
              <div className="p-4 border-b border-border">
                <h3 className="font-medium text-foreground flex items-center space-x-2">
                  <Icon name="TreePine" size={16} />
                  <span>{t("categoryHierarchy")}</span>
                </h3>
              </div>

              <div className="flex-1 overflow-hidden">
                <CategoryTree
                  categories={categories}
                  selectedCategory={selectedCategory}
                  onCategorySelect={handleCategorySelect} // الآن يجلب sub-categories
                  onCategoryDelete={handleCategoryDelete}
                  searchTerm={searchTerm}
                />
              </div>
              {/* Pagination Controls */}
              <div className="flex justify-between p-4">
                <Button
                  variant="outline"
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                >
                  {t("previous")}
                </Button>
                <span>
                  Page {currentPage} {t("of")} {totalPages}
                </span>
                <Button
                  variant="outline"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                >
                  {t("next")}
                </Button>
              </div>
            </div>
          </div>

          {/* Right Panel - Category Details */}
          <div className="col-span-12 lg:col-span-7 space-y-6">
            {/* Tab Navigation - أضف tab جديد إذا أردت، لكن للبساطة استخدم details */}
            {categoryInfo !== null && selectedCategory && (
              <div className="bg-white rounded-lg border border-border shadow-elevation-1">
                <div className="border-b border-border">
                  <nav className="flex space-x-8 px-6">
                    <button
                      onClick={() => setActiveTab("details")}
                      className={`py-4 px-1 border-b-2 font-medium text-sm transition-micro ${
                        activeTab === "details"
                          ? "border-primary text-primary"
                          : "border-transparent text-muted-foreground hover:text-foreground hover:border-muted"
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <Icon name="Info" size={16} />
                        <span>{t("details")}</span>
                      </div>
                    </button>

                    {/* <button
                      onClick={() => setActiveTab("products")}
                      className={`py-4 px-1 border-b-2 font-medium text-sm transition-micro ${
                        activeTab === "products"
                          ? "border-primary text-primary"
                          : "border-transparent text-muted-foreground hover:text-foreground hover:border-muted"
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <Icon name="Package" size={16} />
                        <span></span>
                      </div>
                    </button>*/}

                    {/* Tab جديد للـ sub-categories إذا أردت فصلها 
                    <button
                      onClick={() => setActiveTab("subcategories")}
                      className={`py-4 px-1 border-b-2 font-medium text-sm transition-micro ${
                        activeTab === "subcategories"
                          ? "border-primary text-primary"
                          : "border-transparent text-muted-foreground hover:text-foreground hover:border-muted"
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <span>
                          {t("subCategoriesOf")} (
                          {categoryInfo?.sub_categories?.length})
                        </span>
                      </div>
                    </button>*/}
                  </nav>
                </div>
              </div>
            )}

            {/* Tab Content */}
            {
              <div className="bg-white rounded-lg border border-border shadow-elevation-1 h-full">
                {activeTab === "details" ? (
                  <CategoryDetails
                    category={selectedCategory}
                    categories={categories}
                    subCategories={categoryInfo?.sub_categories} // مرر subCategories
                    onCategoryUpdate={handleCategoryUpdate}
                    onCategoryCreate={handleCategoryCreate}
                    handleSelectCancel={handleSelectCancel}
                    isEditing={isEditing}
                    setIsEditing={setIsEditing}
                    onOpenAddSubCategory={handleOpenAddSubCategoryModal} // مرر handler الزر
                  />
                ) : activeTab === "subcategories" ? (
                  // قسم منفصل لعرض sub-categories فقط (إذا أضفت الـ tab)
                  <div className="p-6">
                    <h3 className="text-lg font-medium mb-4 bold">
                      <span>الفئة الرئيسية : </span>
                      {selectedCategory?.translations?.ar?.name}
                    </h3>
                    {/* عرض sub-categories هنا، مشابه لـ CategoryTree لكن بسيط 
                    <div className="p-6 flex flex-col h-full">
                 
                      <div className="flex items-center justify-between mb-6 pb-4 border-b border-border">
                        <div className="flex items-center space-x-3">
                          <div>
                            <h3 className="text-xl font-semibold text-foreground">
                              الفئات الفرعية
                            </h3>
                            <p className="text-sm text-muted-foreground">
                              للفئة الرئيسية:{" "}
                              {selectedCategory?.translations?.ar?.name}
                            </p>
                          </div>
                        </div>
                        <div className="text-sm text-muted-foreground">
                          {categoryInfo?.sub_categories?.length || 0} فئة فرعية
                        </div>
                      </div>

                
                      <div className="flex-1 overflow-y-auto space-y-3">
                        {categoryInfo?.sub_categories?.length > 0 ? (
                          categoryInfo.sub_categories.map((subCat) => (
                            <div
                              key={subCat.id}
                              className="group flex items-center justify-between p-4 bg-muted/20 rounded-lg border border-border hover:bg-muted transition-all duration-200 cursor-pointer shadow-sm hover:shadow-md"
                              onClick={() => handleSubCategorySelect(subCat)}
                            >
                       
                              <div className="flex items-center space-x-4 flex-1 min-w-0">
                             
                                <div className="w-12 h-12 rounded-lg bg-muted flex items-center justify-center overflow-hidden flex-shrink-0 relative">
                                  {subCat.image ? (
                                    <img
                                      src={subCat.image}
                                      alt={subCat.translations?.ar?.name}
                                      className="w-full h-full object-cover rounded-lg"
                                      onError={(e) => {
                                        e.target.style.display = "none";
                                        e.target.nextSibling.style.display =
                                          "flex";
                                      }}
                                    />
                                  ) : null}
                                </div>

                               
                                <div className="flex-1 min-w-0">
                                  <h4 className="font-medium text-foreground truncate pr-4 leading-tight">
                                    {subCat.translations?.ar?.name}
                                  </h4>
                                  {subCat.translations?.en?.name && (
                                    <p className="text-xs text-muted-foreground truncate pr-4 leading-tight">
                                      ({subCat.translations.en.name})
                                    </p>
                                  )}
                                  {subCat.products_count > 0 && (
                                    <div className="flex items-center space-x-2 mt-1">
                                      <Icon
                                        name="Package"
                                        size={14}
                                        className="text-muted-foreground flex-shrink-0"
                                      />
                                      <span className="text-xs text-muted-foreground font-medium">
                                        {subCat.products_count} منتج
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>

                          <div className="opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-all duration-200 flex items-center ml-4 flex-shrink-0">
  <Button
    variant="ghost"
    size="icon"
    onClick={(e) => {
      e.stopPropagation(); // منع onClick الرئيسي
      handleSubCategoryDelete(subCat.id); // حذف الـ sub-category
    }}
    className="w-9 h-9 p-0 hover:bg-destructive/10 hover:text-destructive text-muted-foreground hover:scale-110 transition-transform duration-200 shadow-sm"
  >
    <Icon name="Trash2" size={16} />
  </Button>
</div>

                            </div>
                          ))
                        ) : (
                          <div className="flex flex-col items-center justify-center flex-1 py-12 text-center">
                            <Icon
                              name="FolderMinus"
                              size={48}
                              className="text-muted-foreground mb-4 opacity-50"
                            />
                            <h4 className="text-lg font-medium text-muted-foreground mb-2">
                              {t("noSubCategories")}
                            </h4>
                            <p className="text-sm text-muted-foreground mb-6 max-w-sm">
                              لا توجد فئات فرعية لهذه الفئة. ابدأ بإضافة واحدة
                              جديدة لتنظيم المنتجات بشكل أفضل.
                            </p>
                          </div>
                        )}
                      </div>

                
                      <div className="pt-4 border-t border-border mt-4">
                        <Button
                          onClick={handleOpenAddSubCategoryModal}
                          className="w-full justify-center py-3 font-medium shadow-sm hover:shadow-md transition-shadow duration-200"
                          variant="outline"
                          iconName="Plus"
                          iconPosition="left"
                          size="lg"
                        >
                          إضافة فئة فرعية جديدة
                        </Button>
                      </div>
                    </div>*/}
                  </div>
                ) : (
                  <CategoryProducts category={selectedCategory} products={[]} />
                )}
              </div>
            }
          </div>
        </div>
      </div>

      {/* Modals - كما هو 
      <BulkActionsModal
        isOpen={showBulkModal}
        onClose={() => setShowBulkModal(false)}
        selectedCategories={selectedCategories}
        categories={categories}
        onBulkAction={handleBulkAction}
      />*/}

      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        category={categoryToDelete}
        categories={categories}
        onConfirm={handleDeleteConfirm}
      />
    </div>
  );
};

export default CategoryManagement;
